import { IInfluencerBooking, UserProfile, UserWorkoutSession } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import {
  influencerBookingCardPressed as influencerBookingCardPressedAction,
  workoutBookingSliderCardPressed as workoutBookingSliderCardPressedAction,
} from '../../Bookings/actions';
import Theme from '../../theme';
import { defaultScale } from '../../utils';
import { getInfluencerAvatarURL } from '../../utils/avatar-helpers';
import { getGymTimezone } from '../../utils/gyms';
import getMomentFormat from '../../utils/LocaleMoment';
import { horizontalScrollConstants } from './HorizontalScroller';
import { HorizontalScrollerCard } from './HorizontalScrollerCard';
import { cardHeaderText, footerText } from './livestream-card-helpers';
import WorkoutSectionCardWithImageContentWrapper from './WorkoutSectionCardWithImageContentWrapper';
import { workoutSliderCardStyle } from './WorkoutSlider';

interface IProps {
  booking: IInfluencerBooking;
  onlyOneCardInSlider: boolean;
  lastCardInSlider: boolean;
  userProfile: UserProfile;
  workoutSession: UserWorkoutSession;
  bookedInfluencerWorkout: boolean;
  influencerName: string;
  influencerUserId: string;
  t(key: string, options?: any): string;
  influencerInviteCardPressed(): void;
  bookedInfluencerCardPressed(): void;
}

const InfluencerWorkoutSliderCard: FunctionComponent<IProps> = (
  {
    onlyOneCardInSlider,
    lastCardInSlider,
    workoutSession,
    influencerInviteCardPressed,
    bookedInfluencerCardPressed,
    bookedInfluencerWorkout,
    influencerName,
    influencerUserId,
    t,
  },
) => {
  const { livestreamOptions } = workoutSession;
  const gymTimeZone = getGymTimezone(workoutSession);
  const dayOfBooking = getMomentFormat(workoutSession.startTimeOfFirstExercise, 'DD MMM', gymTimeZone);
  const bookingTime = getMomentFormat(workoutSession.startTimeOfFirstExercise, 'hh:mmA z', gymTimeZone);
  const influencerImageUrl = getInfluencerAvatarURL(influencerUserId);

  return (
    <HorizontalScrollerCard
      style={[workoutSliderCardStyle.container, {}]}
      onPress={bookedInfluencerWorkout ? bookedInfluencerCardPressed : influencerInviteCardPressed}
      wideCard={onlyOneCardInSlider}
      lastCard={lastCardInSlider}
    >
      <WorkoutSectionCardWithImageContentWrapper
        imageHeight={horizontalScrollConstants.CARD_HEIGHT}
        imageWidth={horizontalScrollConstants.CARD_HEIGHT}
        image={{ uri: influencerImageUrl }}
        applyImageGradient
      />

      <View style={styles.contentContainer}>
        <View>
          <Text style={[styles.heading, { color: Theme.PRIMARY }, bookedInfluencerWorkout && { color: Theme.WHITE }]}>
            {cardHeaderText(t, bookedInfluencerWorkout, livestreamOptions)}
          </Text>
          <Text style={styles.bookingText}>
            {t('InfluencerInviteCardDate', { date: dayOfBooking, time: bookingTime })}
          </Text>
        </View>

        <View>
          <Text style={styles.footerText}>
            {footerText(influencerName, t, livestreamOptions)}
          </Text>
        </View>
      </View>
    </HorizontalScrollerCard>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    flex: 1,
    zIndex: 5,
    justifyContent: 'space-between',
  },
  heading: {
    ...Theme.textStyle.bodyCopyBold,
  },
  bookingText: {
    ...Theme.textStyle.bodyCopyMed,
    color: Theme.WHITE,
  },
  textContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  footerText: {
    ...Theme.textStyle.heading,
    color: Theme.WHITE,
  },
  label: {
    flexDirection: 'row',
  },
  labelText: {
    borderRadius: 20,
    backgroundColor: Theme.PRIMARY,
    paddingHorizontal: defaultScale(10),
    color: Theme.WHITE,
  },
});

const mapDispatchToProps = (dispatch, ownProps: IProps) => {
  const { userProfile, workoutSession } = ownProps;
  return {
    influencerInviteCardPressed: () => dispatch(influencerBookingCardPressedAction(userProfile, workoutSession)),
    bookedInfluencerCardPressed: () => dispatch(workoutBookingSliderCardPressedAction(userProfile, workoutSession)),
  };
};

export default connect(null, mapDispatchToProps)(InfluencerWorkoutSliderCard);
